import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { KexpSteeringWheelComponent } from './steering-wheel.component';
import { SteeringMode } from '@splixer/common';
import { SteeringDialogData } from '../../../services/dialogs.service';
import { uString } from '@hidat/huijs-common';

@Component({
  selector: 'kexp-steering-wheel-dialog',
  templateUrl: 'steering-wheel.dialog.html',
  imports: [FaIconComponent, KexpSteeringWheelComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class KexpSteeringWheelDialog implements OnInit {
  protected dialogRef = inject<DialogRef<string>>(DialogRef<string>);

  protected steeringMode = signal<SteeringMode>(SteeringMode.UpNext);
  protected readonly faXmark = faXmark;

  ngOnInit() {
    console.debug('Loading steering wheel');
    const data = this.dialogRef.config.data as SteeringDialogData;
    if (data?.steeringMode) {
      this.steeringMode.set(data.steeringMode);
    }
  }

  protected pageTitle = computed(() => {
    let title = 'The Steering Wheel';
    /*
    const sm = this.steeringMode();
    if (sm !== SteeringMode.SkipTo) {
      if (sm === SteeringMode.StartingPath) {
        title = 'Choose Your Start'
      } else {
        title = 'Up Next';
      }
    }*/
    return title;
  });

  protected topInstructions = computed(() => {
    let instructions = 'Select a past show to listen to';
    const sm = this.steeringMode();
    if (sm === SteeringMode.ChooseNextMix) {
      instructions = 'Choose your next show or mix to listen to next';
    }
    return instructions;
  });

  protected bottomInstructions = computed(() => {
    let instructions: uString;
    const sm = this.steeringMode();
    if (sm === SteeringMode.StartingPath) {
      instructions = 'Click the steering wheel for more choices.';
    }
    return instructions;
  });

  closeDialog = () => {
    this.dialogRef.close();
  };
}
